import React, { Component } from "react";
import { fire, auth } from "../../firebase/index";

import LocalizedStrings from "react-localization";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    noDataTitle: "No Data Found",
  },
  ja: {
    noDataTitle: "データーがありません",
  },
  es: {
    noDataTitle: "No se encontraron datos",
  },
});

// import noDataFoundImg from '../../assets/img/nodata.png'

class NoDataFound extends Component {
  state = {
    currentLanguage: localizationStrings.getLanguage() || "en",
  };

  componentWillMount() {
    //! LANGUAGE SETTING
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    return (
      // <img style={styles} src={noDataFoundImg} alt="No Data can be found" />
      <div>
        <h2>{localizationStrings.noDataTitle}</h2>
      </div>
    );
  }
}

export default NoDataFound;
